import { useSearchAdsCountSinceLastViewedQuery } from 'src/hooks/__generated__/queries';

type Params = {
    searchId: string;
};

export const useSavedSearchAdsCountSinceLastViewed = ({ searchId }: Params) => {
    const { data, loading } = useSearchAdsCountSinceLastViewedQuery({
        variables: {
            searchId,
        },
        fetchPolicy: 'cache-and-network',
    });

    return {
        loading,
        savedSearchAdsCountSinceLastViewed: data?.searchAdsCountSinceLastViewed,
    };
};
